
import { onMounted, ref, defineComponent } from 'vue';

export default defineComponent({
  name: 'Locations',

  setup() {
    const locations = ref([] as any);
    const page = ref(1);

    const load = async () => {
      const res = await fetch(
        `https://rickandmortyapi.com/api/location/?page=${page.value}`
      );

      const data = await res.json();
      locations.value = data.results;

      console.log(locations.value);
    };
    onMounted(load);

    const next = async () => {
      page.value++;
      await load();
    };

    const prev = async () => {
      page.value--;
      await load();
    };

    return {
      locations,
      next,
      prev,
    };
  },
});
